var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnirv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 265.41,
    height: 111.346,
    viewBox: "0 0 265.41 111.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_97",
    "data-name": "Grupo 97",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_79",
    "data-name": "Grupo 79",
    transform: "translate(0 93.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_47",
    "data-name": "Grupo 47",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(0 0.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12",
    "data-name": "Grupo 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_93",
    "data-name": "Caminho 93",
    d: "M6106.967,3494.764a43.389,43.389,0,0,1-4.861.276c-4.1,0-6.225-1.568-6.225-6.627V3478.28a.435.435,0,0,1,.408-.46h1.277a.423.423,0,0,1,.389.46v10.134c0,3.979,1.371,4.79,4.2,4.79.98,0,2.807-.093,3.377-.139V3478.28a.436.436,0,0,1,.41-.46h1.256a.428.428,0,0,1,.414.46v15.746C6107.609,3494.6,6107.422,3494.689,6106.967,3494.764Z",
    transform: "translate(-6095.881 -3477.82)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    "data-name": "Grupo 16",
    transform: "translate(15.061 4.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15",
    "data-name": "Grupo 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14",
    "data-name": "Grupo 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_94",
    "data-name": "Caminho 94",
    d: "M6585.983,3626.723H6584.8a.429.429,0,0,1-.418-.462v-8.187c0-1.714-.437-2.389-1.986-2.389h-1.613c-1.555,0-1.984.675-1.984,2.389v8.187a.428.428,0,0,1-.414.462H6577.2a.425.425,0,0,1-.406-.462v-8.187c0-3.524,2.438-4.124,3.992-4.124h1.613c1.549,0,4,.6,4,4.124v8.187A.427.427,0,0,1,6585.983,3626.723Z",
    transform: "translate(-6576.79 -3613.95)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19",
    "data-name": "Grupo 19",
    transform: "translate(27.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18",
    "data-name": "Grupo 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17",
    "data-name": "Grupo 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95",
    "data-name": "Caminho 95",
    d: "M6991.422,3469.364h-1.168a.458.458,0,0,1-.453-.454v-1.834a.461.461,0,0,1,.453-.466h1.168a.457.457,0,0,1,.453.466v1.834A.454.454,0,0,1,6991.422,3469.364Zm-.051,14.637h-1.09a.467.467,0,0,1-.459-.463v-11.692a.458.458,0,0,1,.459-.452h1.09a.454.454,0,0,1,.459.452v11.692A.463.463,0,0,1,6991.371,3484Z",
    transform: "translate(-6989.801 -3466.61)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22",
    "data-name": "Grupo 22",
    transform: "translate(32.743 4.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    "data-name": "Grupo 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_96",
    "data-name": "Caminho 96",
    d: "M7151.693,3619.833l-2.918,10.412a2.257,2.257,0,0,1-4.424,0l-2.924-10.412a.6.6,0,0,1-.018-.155.346.346,0,0,1,.361-.388h1.256c.182,0,.363.128.432.433l2.561,9.939c.133.583.316.72.545.72.205,0,.412-.137.543-.72l2.557-9.939c.07-.3.252-.433.439-.433h1.279a.31.31,0,0,1,.338.349A.554.554,0,0,1,7151.693,3619.833Z",
    transform: "translate(-7141.41 -3619.291)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    transform: "translate(45.132 4.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23",
    "data-name": "Grupo 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_97",
    "data-name": "Caminho 97",
    d: "M7546.654,3621.056h-7.639v.277c0,2.64,1.238,3.849,3.332,3.849a26.917,26.917,0,0,0,3.895-.323h.121a.324.324,0,0,1,.361.323v.776c0,.3-.09.451-.459.534a19.066,19.066,0,0,1-3.918.389c-2.623,0-5.338-1.266-5.338-5.668v-1.6c0-3.257,1.8-5.667,5.064-5.667,3.332,0,5.02,2.381,5.02,5.639v.97A.445.445,0,0,1,7546.654,3621.056Zm-1.592-1.651h0c0-2.453-.979-3.683-2.988-3.683-1.959,0-3.059,1.331-3.059,3.683v.12h6.047Z",
    transform: "translate(-7537.01 -3613.95)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    transform: "translate(57.911 4.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26",
    "data-name": "Grupo 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_98",
    "data-name": "Caminho 98",
    d: "M7950.22,3615.72a14.81,14.81,0,0,0-3.174.216v10.326a.436.436,0,0,1-.412.461h-1.184a.438.438,0,0,1-.41-.461v-11.15a.624.624,0,0,1,.41-.535,12.034,12.034,0,0,1,4.77-.627c.293,0,.473.021.473.352v1.043C7950.692,3615.593,7950.646,3615.72,7950.22,3615.72Z",
    transform: "translate(-7945.04 -3613.95)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31",
    "data-name": "Grupo 31",
    transform: "translate(65.575 4.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29",
    "data-name": "Grupo 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_99",
    "data-name": "Caminho 99",
    d: "M8193.843,3626.881a19.605,19.605,0,0,1-3.6-.341c-.3-.074-.48-.221-.48-.464v-.8a.37.37,0,0,1,.408-.341h.092c1.1.139,2.766.249,3.582.249,1.482,0,2.256-.388,2.256-1.625,0-.691-.406-1.126-1.715-1.9l-2.3-1.377c-1.393-.86-2.326-1.845-2.326-3.286,0-2.381,1.777-3.046,4.127-3.046a21.064,21.064,0,0,1,3.566.3c.289.054.428.2.428.459v.759a.351.351,0,0,1-.385.387h-.074c-.8-.064-2.252-.186-3.535-.186s-2.115.167-2.115,1.33c0,.692.518,1.125,1.57,1.753l2.254,1.348c1.9,1.116,2.512,2.1,2.512,3.46C8198.108,3625.892,8196.4,3626.881,8193.843,3626.881Z",
    transform: "translate(-8189.761 -3613.95)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34",
    transform: "translate(76.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33",
    "data-name": "Grupo 33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32",
    "data-name": "Grupo 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_100",
    "data-name": "Caminho 100",
    d: "M8551.16,3469.364H8550a.469.469,0,0,1-.463-.454v-1.834a.472.472,0,0,1,.463-.466h1.158a.467.467,0,0,1,.467.466v1.834A.465.465,0,0,1,8551.16,3469.364Zm-.043,14.637h-1.094a.472.472,0,0,1-.463-.463v-11.692a.462.462,0,0,1,.463-.452h1.094a.457.457,0,0,1,.455.452v11.692A.466.466,0,0,1,8551.117,3484Z",
    transform: "translate(-8549.539 -3466.61)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_37",
    "data-name": "Grupo 37",
    transform: "translate(81.843 0.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36",
    "data-name": "Grupo 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35",
    "data-name": "Grupo 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_101",
    "data-name": "Caminho 101",
    d: "M8718.388,3488.059a22.291,22.291,0,0,1-4.193.389c-3.406,0-4.973-2.225-4.973-5.667v-1.651c0-3.6,1.648-5.613,4.973-5.613a15.982,15.982,0,0,1,2.67.223v-4.255a.443.443,0,0,1,.436-.444h1.158a.426.426,0,0,1,.418.444v16.041C8718.876,3487.827,8718.806,3487.976,8718.388,3488.059Zm-1.523-10.623h0a17.678,17.678,0,0,0-2.67-.147c-2.236,0-2.963,1.386-2.963,3.841v1.651c0,2.5.7,3.9,2.963,3.9.775,0,1.9-.073,2.67-.141Z",
    transform: "translate(-8709.222 -3471.039)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_40",
    "data-name": "Grupo 40",
    transform: "translate(94.185 4.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_39",
    "data-name": "Grupo 39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_38",
    "data-name": "Grupo 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_102",
    "data-name": "Caminho 102",
    d: "M9112.5,3626.356a19.112,19.112,0,0,1-4.2.524c-3.4,0-4.971-2.227-4.971-5.668v-1.6c0-3.441,1.543-5.667,4.971-5.667a19.283,19.283,0,0,1,4.2.516c.406.1.475.226.475.537v10.835C9112.979,3626.117,9112.91,3626.261,9112.5,3626.356Zm-1.533-10.486h0a16.841,16.841,0,0,0-2.67-.231c-2.256,0-2.969,1.532-2.969,3.979v1.6c0,2.41.713,3.969,2.969,3.969a16.245,16.245,0,0,0,2.67-.229Z",
    transform: "translate(-9103.33 -3613.95)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43",
    "data-name": "Grupo 43",
    transform: "translate(106.529 0.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42",
    "data-name": "Grupo 42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_41",
    "data-name": "Grupo 41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_103",
    "data-name": "Caminho 103",
    d: "M9506.631,3488.059a22.354,22.354,0,0,1-4.205.389c-3.391,0-4.967-2.225-4.967-5.667v-1.651c0-3.6,1.643-5.613,4.967-5.613a16.038,16.038,0,0,1,2.678.223v-4.255a.438.438,0,0,1,.434-.444h1.164a.425.425,0,0,1,.412.444v16.041C9507.113,3487.827,9507.043,3487.976,9506.631,3488.059Zm-1.527-10.623h0a17.711,17.711,0,0,0-2.678-.147c-2.23,0-2.961,1.386-2.961,3.841v1.651c0,2.5.715,3.9,2.961,3.9.787,0,1.9-.073,2.678-.141Z",
    transform: "translate(-9497.459 -3471.039)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_46",
    "data-name": "Grupo 46",
    transform: "translate(118.92 4.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_45",
    "data-name": "Grupo 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_104",
    "data-name": "Caminho 104",
    d: "M9902.785,3621.056h-7.635v.277c0,2.64,1.23,3.849,3.332,3.849a27.273,27.273,0,0,0,3.9-.323h.107a.328.328,0,0,1,.365.323v.776c0,.3-.088.451-.451.534a19.181,19.181,0,0,1-3.924.389c-2.631,0-5.342-1.266-5.342-5.668v-1.6c0-3.257,1.8-5.667,5.057-5.667,3.332,0,5.023,2.381,5.023,5.639v.97A.44.44,0,0,1,9902.785,3621.056Zm-1.59-1.651h0c0-2.453-.99-3.683-3-3.683-1.957,0-3.047,1.331-3.047,3.683v.12h6.045Z",
    transform: "translate(-9893.141 -3613.95)",
    fill: "#055e43",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_78",
    "data-name": "Grupo 78",
    transform: "translate(138.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_50",
    "data-name": "Grupo 50",
    transform: "translate(0 0.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_49",
    "data-name": "Grupo 49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_48",
    "data-name": "Grupo 48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_105",
    "data-name": "Caminho 105",
    d: "M10515.461,3488.049a21.911,21.911,0,0,1-4.2.389c-3.4,0-4.973-2.226-4.973-5.669v-1.643c0-3.609,1.643-5.619,4.973-5.619a15.985,15.985,0,0,1,2.672.23v-4.266a.426.426,0,0,1,.434-.433h1.16a.418.418,0,0,1,.416.433v16.042C10515.943,3487.828,10515.873,3487.975,10515.461,3488.049Zm-1.527-10.616h0a16.673,16.673,0,0,0-2.672-.162c-2.236,0-2.961,1.4-2.961,3.855v1.643c0,2.491.709,3.9,2.961,3.9.775,0,1.891-.057,2.672-.131Z",
    transform: "translate(-10506.289 -3471.04)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_53",
    "data-name": "Grupo 53",
    transform: "translate(12.389 4.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_52",
    "data-name": "Grupo 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_51",
    "data-name": "Grupo 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_106",
    "data-name": "Caminho 106",
    d: "M10911.531,3620.776h-7.645v.278c0,2.631,1.232,3.847,3.33,3.847a26.087,26.087,0,0,0,3.908-.321h.109a.325.325,0,0,1,.363.321v.775c0,.315-.088.463-.463.537a19.921,19.921,0,0,1-3.918.387c-2.631,0-5.336-1.255-5.336-5.667v-1.6c0-3.267,1.8-5.665,5.072-5.665,3.326,0,5.006,2.392,5.006,5.638v.962C10911.959,3620.575,10911.8,3620.776,10911.531,3620.776Zm-1.6-1.65h0c0-2.446-.979-3.691-2.979-3.691-1.973,0-3.066,1.327-3.066,3.691v.118h6.045Z",
    transform: "translate(-10901.881 -3613.67)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56",
    "data-name": "Grupo 56",
    transform: "translate(31.626 0.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_55",
    "data-name": "Grupo 55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_54",
    "data-name": "Grupo 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_107",
    "data-name": "Caminho 107",
    d: "M11527.477,3489.712h-1.6c-.275,0-.32,0-.5-.3l-4.078-6.83h-.6c-.746,0-1.939-.036-2.512-.066v6.75a.433.433,0,0,1-.416.449h-1.221a.43.43,0,0,1-.412-.449V3473.2c0-.323.137-.459.539-.506.988-.111,2.7-.176,4.021-.176,3.605,0,6.391,1.218,6.391,4.93v.146a4.49,4.49,0,0,1-3.582,4.633l4.193,7.042a.392.392,0,0,1,.07.212C11527.773,3489.611,11527.68,3489.712,11527.477,3489.712Zm-2.439-12.263h0c0-2.289-1.488-3.056-4.336-3.056-.709,0-1.967,0-2.512.062v6.3c.484,0,1.984.045,2.512.045,2.809,0,4.336-.71,4.336-3.2Z",
    transform: "translate(-11516.141 -3472.52)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59",
    "data-name": "Grupo 59",
    transform: "translate(45.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58",
    "data-name": "Grupo 58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57",
    "data-name": "Grupo 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_108",
    "data-name": "Caminho 108",
    d: "M11973.176,3469.361h-1.164a.458.458,0,0,1-.453-.461v-1.829a.458.458,0,0,1,.453-.461h1.164a.454.454,0,0,1,.457.461v1.829A.454.454,0,0,1,11973.176,3469.361Zm-.039,14.629h-1.1a.454.454,0,0,1-.457-.453v-11.7a.469.469,0,0,1,.457-.463h1.1a.466.466,0,0,1,.453.463v11.7A.451.451,0,0,1,11973.137,3483.99Z",
    transform: "translate(-11971.559 -3466.61)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_62",
    "data-name": "Grupo 62",
    transform: "translate(50.882 4.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_61",
    "data-name": "Grupo 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_60",
    "data-name": "Grupo 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_109",
    "data-name": "Caminho 109",
    d: "M12136.061,3626.6c-3.34,0-5.059-2.224-5.059-5.593v-1.733c0-3.388,1.719-5.6,5.059-5.6,3.359,0,5.1,2.216,5.1,5.6v1.733C12141.158,3624.376,12139.42,3626.6,12136.061,3626.6Zm3.086-7.326h0c0-2.345-.93-3.84-3.086-3.84-2.121,0-3.055,1.468-3.055,3.84v1.733c0,2.344.918,3.821,3.055,3.821,2.121,0,3.086-1.459,3.086-3.821Z",
    transform: "translate(-12131.002 -3613.67)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65",
    "data-name": "Grupo 65",
    transform: "translate(69.179 0.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_64",
    "data-name": "Grupo 64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_63",
    "data-name": "Grupo 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_110",
    "data-name": "Caminho 110",
    d: "M12728.361,3478.026l-4.2,14.933a2.423,2.423,0,0,1-4.648,0l-4.23-14.933a.286.286,0,0,1-.023-.139.393.393,0,0,1,.418-.387h1.32a.453.453,0,0,1,.406.341l3.973,14.6c.086.323.2.48.449.48s.348-.157.434-.48l3.992-14.6a.456.456,0,0,1,.395-.341H12728a.371.371,0,0,1,.383.387A.337.337,0,0,1,12728.361,3478.026Z",
    transform: "translate(-12715.26 -3477.5)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_68",
    "data-name": "Grupo 68",
    transform: "translate(84.263 4.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67",
    "data-name": "Grupo 67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_66",
    "data-name": "Grupo 66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_111",
    "data-name": "Caminho 111",
    d: "M13206.561,3620.776h-7.645v.278c0,2.631,1.23,3.847,3.336,3.847a25.94,25.94,0,0,0,3.895-.321h.117a.32.32,0,0,1,.363.321v.775c0,.315-.09.463-.457.537a19.982,19.982,0,0,1-3.918.387c-2.625,0-5.34-1.255-5.34-5.667v-1.6c0-3.267,1.8-5.665,5.059-5.665,3.332,0,5.02,2.392,5.02,5.638v.962C13206.99,3620.575,13206.834,3620.776,13206.561,3620.776Zm-1.594-1.65h0c0-2.446-.984-3.691-3-3.691-1.961,0-3.055,1.327-3.055,3.691v.118h6.051Z",
    transform: "translate(-13196.912 -3613.67)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_71",
    "data-name": "Grupo 71",
    transform: "translate(97.042 4.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_70",
    "data-name": "Grupo 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_69",
    "data-name": "Grupo 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_112",
    "data-name": "Caminho 112",
    d: "M13610.111,3615.432a14.079,14.079,0,0,0-3.172.232v10.326a.428.428,0,0,1-.406.451h-1.187a.427.427,0,0,1-.406-.451v-11.149c0-.26.148-.406.406-.536a12.028,12.028,0,0,1,4.766-.636c.3,0,.477.028.477.341v1.062C13610.588,3615.321,13610.549,3615.432,13610.111,3615.432Z",
    transform: "translate(-13604.939 -3613.669)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_74",
    "data-name": "Grupo 74",
    transform: "translate(104.707 0.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_73",
    "data-name": "Grupo 73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_72",
    "data-name": "Grupo 72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_113",
    "data-name": "Caminho 113",
    d: "M13858.875,3488.049a21.7,21.7,0,0,1-4.191.389c-3.4,0-4.973-2.226-4.973-5.669v-1.643c0-3.609,1.641-5.619,4.973-5.619a15.881,15.881,0,0,1,2.664.23v-4.266a.438.438,0,0,1,.441-.433h1.164a.414.414,0,0,1,.41.433v16.042C13859.363,3487.828,13859.289,3487.975,13858.875,3488.049Zm-1.527-10.616h0a16.483,16.483,0,0,0-2.664-.162c-2.238,0-2.973,1.4-2.973,3.855v1.643c0,2.491.719,3.9,2.973,3.9.773,0,1.883-.057,2.664-.131Z",
    transform: "translate(-13849.711 -3471.04)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_77",
    "data-name": "Grupo 77",
    transform: "translate(117.101 4.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_76",
    "data-name": "Grupo 76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_75",
    "data-name": "Grupo 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_114",
    "data-name": "Caminho 114",
    d: "M14255.109,3620.776h-7.637v.278c0,2.631,1.219,3.847,3.32,3.847a25.775,25.775,0,0,0,3.9-.321h.121a.324.324,0,0,1,.359.321v.775c0,.315-.09.463-.453.537a20.064,20.064,0,0,1-3.926.387c-2.625,0-5.332-1.255-5.332-5.667v-1.6c0-3.267,1.793-5.665,5.055-5.665,3.336,0,5.023,2.392,5.023,5.638v.962C14255.539,3620.575,14255.375,3620.776,14255.109,3620.776Zm-1.605-1.65h0c0-2.446-.965-3.691-2.988-3.691-1.957,0-3.043,1.327-3.043,3.691v.118h6.031Z",
    transform: "translate(-14245.461 -3613.67)",
    fill: "#055e43",
    fillRule: "evenodd"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_82",
    "data-name": "Grupo 82",
    transform: "translate(161.478 16.187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_80",
    "data-name": "Grupo 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_115",
    "data-name": "Caminho 115",
    d: "M11297.875,1008.236a23.122,23.122,0,0,1-.861,6.535,23.732,23.732,0,0,1-2.166,5.167,16.969,16.969,0,0,1-2.984,3.858,16.391,16.391,0,0,1-3.3,2.492l13.293,22.887a34.368,34.368,0,0,1-4.566,1.763,19.678,19.678,0,0,1-5.83.766,18.228,18.228,0,0,1-7.363-1.264,11.566,11.566,0,0,1-5.012-4.809l-7.584-14.888h-1.176v19.8h-18.25V990.167c3.193-.37,6.445-.619,9.76-.775s6.105-.223,8.4-.223q14,0,20.816,4.67T11297.875,1008.236Zm-19.156,1.81h0a10.325,10.325,0,0,0-1.621-6.257,5.4,5.4,0,0,0-4.615-2.187,5.251,5.251,0,0,0-.8.046,6.475,6.475,0,0,1-.725.046,2.9,2.9,0,0,1-.721.093v17.248h2.248a5,5,0,0,0,4.836-2.64A13.31,13.31,0,0,0,11278.719,1010.047Z",
    transform: "translate(-11252.072 -989.17)",
    fill: "#00a859",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_81",
    "data-name": "Grupo 81",
    transform: "translate(44.671 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_116",
    "data-name": "Caminho 116",
    d: "M12717.939,1051h-20.152l-19.328-60.459a8.575,8.575,0,0,1,1.941-.516c.875-.147,1.82-.3,2.852-.444s2.027-.259,3.023-.314c.992-.073,1.848-.092,2.57-.092q9.3,0,11.023,7.715l7.945,34.591h.633l8.309-34.047a11.107,11.107,0,0,1,3.578-5.99,10.851,10.851,0,0,1,7.27-2.269,31.538,31.538,0,0,1,4.789.36c1.625.24,3.406.609,5.328,1.08Z",
    transform: "translate(-12678.459 -989.17)",
    fill: "#00a859",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_117",
    "data-name": "Caminho 117",
    d: "M6577.787,982.251V963.22h-18.156v5.044C6568.988,967.882,6575.574,970.39,6577.787,982.251Z",
    transform: "translate(-6545.107 -947.845)",
    fill: "#00a859",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_83",
    "data-name": "Grupo 83",
    transform: "translate(69.927 32.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_118",
    "data-name": "Caminho 118",
    d: "M8353.489,1529.148a8.929,8.929,0,0,0-.457-3.176c-.3-.8-1.107-1.189-2.432-1.189a3.95,3.95,0,0,0-2.85.857,2.668,2.668,0,0,0-.857,1.865v28.333h-18.156v-43.4c.547-.12,1.18-.23,1.9-.36a22.087,22.087,0,0,1,2.262-.278c.846-.055,1.809-.093,2.891-.093a15.507,15.507,0,0,1,6.646,1.228,6.711,6.711,0,0,1,3.471,3.313,11.068,11.068,0,0,1,4.016-3.674,15.285,15.285,0,0,1,7.912-1.77c3.73,0,6.678.9,8.852,2.73a12.608,12.608,0,0,1,4.24,7.163,14.279,14.279,0,0,1,.406,2.308c.094.885.154,1.761.182,2.638s.061,1.753.1,2.595.041,1.576.041,2.186v25.049a14.4,14.4,0,0,1-1.9.626c-.6.131-1.3.249-2.111.371a18.7,18.7,0,0,1-2.666.184,16.7,16.7,0,0,1-6.459-1,7.4,7.4,0,0,1-4.789-6.406,43.669,43.669,0,0,1-.229-4.485Z",
    transform: "translate(-8328.737 -1510.8)",
    fill: "#055e43",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_85",
    "data-name": "Grupo 85",
    transform: "translate(14.523 11.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_119",
    "data-name": "Caminho 119",
    d: "M6577.787,1026.031a24.716,24.716,0,0,0,.723,6.71,8.438,8.438,0,0,0,2.07,3.359,5.885,5.885,0,0,0,4.342,1.448,6.608,6.608,0,0,0,3.754-1.043,6.1,6.1,0,0,0,2.3-3.672,20.013,20.013,0,0,0,.4-2.963c.1-1.162.137-2.455.137-3.839V989.8c.9-.064,1.779-.148,2.623-.268.727-.12,1.473-.212,2.254-.268.787-.073,1.477-.093,2.08-.093a24.35,24.35,0,0,1,3.7.314,11.337,11.337,0,0,1,3.666,1.265,7.676,7.676,0,0,1,2.756,2.778,9.156,9.156,0,0,1,1.078,4.716v27.235q0,1.828-.09,3.82c-.061,1.33-.148,2.695-.271,4.08a21.489,21.489,0,0,1-1.937,7.171,17.4,17.4,0,0,1-4.561,5.9,21.518,21.518,0,0,1-7.457,4,34.477,34.477,0,0,1-10.611,1.457,40.2,40.2,0,0,1-10.393-1.191,19.478,19.478,0,0,1-7.406-3.58,16.806,16.806,0,0,1-4.652-5.9,27.456,27.456,0,0,1-2.3-8.132q-.176-1.716-.268-3.9-.091-2.172-.09-3.719V995.371c9.25-.47,15.793.842,18.156,12.018Zm0-27.983h0v0Z",
    transform: "translate(-6559.631 -984.629)",
    fill: "#055e43",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_84",
    "data-name": "Grupo 84",
    transform: "translate(102.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_120",
    "data-name": "Caminho 120",
    d: "M9847.18,852.717a7.9,7.9,0,0,1-2.527,6.176,9.957,9.957,0,0,1-12.656,0,7.9,7.9,0,0,1-2.527-6.176A8.048,8.048,0,0,1,9832,846.5a9.835,9.835,0,0,1,12.656,0A8.048,8.048,0,0,1,9847.18,852.717Zm.627,57.017h0a21.9,21.9,0,0,1-6.562,1.183,16.574,16.574,0,0,1-6.424-1,7.8,7.8,0,0,1-3.418-2.639,8.093,8.093,0,0,1-1.346-3.766,43.121,43.121,0,0,1-.23-4.485V866.607l2.252-.268q1-.181,2.205-.278c.807-.055,1.6-.093,2.373-.093a21.4,21.4,0,0,1,4.188.408,9.757,9.757,0,0,1,3.551,1.457,7.521,7.521,0,0,1,2.467,2.908,10.476,10.476,0,0,1,.945,4.771Z",
    transform: "translate(-9829.469 -844.19)",
    fill: "#055e43",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_86",
    "data-name": "Grupo 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_121",
    "data-name": "Caminho 121",
    d: "M6110.813,472.29h119.926a14.857,14.857,0,0,1,10.547,4.4,15.018,15.018,0,0,1,4.391,10.6v60.543a15.058,15.058,0,0,1-4.391,10.613,14.858,14.858,0,0,1-10.547,4.4H6110.813a15,15,0,0,1-14.932-15.016V487.3a15,15,0,0,1,14.932-15.006Zm119.926,2.594H6110.813a12.4,12.4,0,0,0-12.352,12.413v60.543a12.467,12.467,0,0,0,3.631,8.786,12.3,12.3,0,0,0,8.721,3.637h119.926a12.309,12.309,0,0,0,8.725-3.637,12.485,12.485,0,0,0,3.633-8.786V487.3a12.408,12.408,0,0,0-12.357-12.413Z",
    transform: "translate(-6095.881 -472.29)",
    fill: "#055e43",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_122",
    "data-name": "Caminho 122",
    d: "M6310.579,555.1h-119.93a12.408,12.408,0,0,0-12.35,12.413v60.543a12.449,12.449,0,0,0,3.633,8.786,12.287,12.287,0,0,0,8.717,3.637h119.93a12.3,12.3,0,0,0,8.721-3.637,12.482,12.482,0,0,0,3.633-8.786V567.513a12.429,12.429,0,0,0-3.633-8.777A12.3,12.3,0,0,0,6310.579,555.1Zm-17.934,17.581a8.049,8.049,0,0,1,2.527-6.221,9.828,9.828,0,0,1,12.652,0,8.053,8.053,0,0,1,2.533,6.221,7.9,7.9,0,0,1-2.533,6.175,9.952,9.952,0,0,1-12.652,0A7.9,7.9,0,0,1,6292.646,572.681Zm-17.912,12.349q5.6,0,8.855,2.731a12.648,12.648,0,0,1,4.242,7.162,15.648,15.648,0,0,1,.41,2.307c.09.886.15,1.761.178,2.64s.061,1.753.092,2.594.045,1.577.045,2.186V629.7a14.489,14.489,0,0,1-1.9.628c-.6.13-1.3.248-2.117.37a18.6,18.6,0,0,1-2.668.185,16.7,16.7,0,0,1-6.453-1,7.9,7.9,0,0,1-3.437-2.64,8.016,8.016,0,0,1-1.355-3.766,42.636,42.636,0,0,1-.225-4.485V603.378a9.044,9.044,0,0,0-.451-3.176c-.3-.8-1.117-1.189-2.441-1.189a3.93,3.93,0,0,0-2.844.857,2.631,2.631,0,0,0-.861,1.864v28.334h-18.152v-43.4c.541-.12,1.172-.23,1.895-.36a22.4,22.4,0,0,1,2.26-.278c.846-.055,1.8-.092,2.893-.092a15.426,15.426,0,0,1,6.639,1.229,6.709,6.709,0,0,1,3.475,3.313,11.131,11.131,0,0,1,4.021-3.675A15.255,15.255,0,0,1,6274.733,585.029ZM6293,618.992V586.571l2.252-.268c.66-.12,1.4-.213,2.2-.278s1.6-.092,2.381-.092a21.545,21.545,0,0,1,4.188.407,9.763,9.763,0,0,1,3.543,1.457,7.494,7.494,0,0,1,2.469,2.909,10.473,10.473,0,0,1,.945,4.77V629.7a21.878,21.878,0,0,1-6.564,1.183,16.563,16.563,0,0,1-6.424-1,7.848,7.848,0,0,1-3.416-2.64,8.025,8.025,0,0,1-1.344-3.766A44.213,44.213,0,0,1,6293,618.992Zm-84.6-32.08c-2.211-11.862-8.8-14.369-18.156-13.988v-5.044H6208.4Zm0,0v0Zm31.889-9.147V605q0,1.828-.092,3.821c-.061,1.33-.146,2.7-.273,4.08a21.354,21.354,0,0,1-1.939,7.171,17.315,17.315,0,0,1-4.559,5.9,21.505,21.505,0,0,1-7.453,4,34.517,34.517,0,0,1-10.611,1.457,40.208,40.208,0,0,1-10.395-1.191,19.43,19.43,0,0,1-7.4-3.581,16.807,16.807,0,0,1-4.658-5.9,27.345,27.345,0,0,1-2.3-8.133q-.182-1.714-.271-3.9-.091-2.171-.092-3.719V574.9c9.252-.471,15.791.841,18.156,12.017v18.642a24.641,24.641,0,0,0,.723,6.71,8.473,8.473,0,0,0,2.074,3.359,5.877,5.877,0,0,0,4.342,1.449,6.606,6.606,0,0,0,3.75-1.044,6.077,6.077,0,0,0,2.3-3.672,20.576,20.576,0,0,0,.4-2.963c.1-1.163.139-2.455.139-3.839V569.321c.9-.064,1.779-.147,2.621-.268.723-.12,1.475-.212,2.254-.267.785-.073,1.475-.093,2.08-.093a24.526,24.526,0,0,1,3.7.314,11.342,11.342,0,0,1,3.664,1.265,7.7,7.7,0,0,1,2.756,2.778A9.2,9.2,0,0,1,6240.288,577.766Z",
    transform: "translate(-6175.717 -552.506)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnirv);
export default __webpack_public_path__ + "static/media/unirv.79288c9783ac6e3e7c76b1fe78dd8765.svg";
export { ForwardRef as ReactComponent };